import Styles from './Show.scss';

import Template from './Show.hbs';
import ChapterView from 'views/pages/groups/show/chapterView/ChapterView';
import HeroButton from 'views/components/heroButton/HeroButton';
import ContentLabel from 'views/components/contentLabel/ContentLabel';
import TeacherMaterialModal from 'views/pages/groups/show/teacherMaterial/TeacherMaterial';
import SearchInput from './SearchInput.svelte';
import SetVisibility from 'views/components/modals/setVisibility/SetVisibility';
import Module from './Module.svelte'
import {createContentDomainFilterHeroDropdown} from 'views/components/contentDomainDropdown/ContentDomainDropdown'
import HeroDropdown from 'views/components/heroButton/heroDropdown/HeroDropdown';
import { exportShareLinks } from 'views/pages/groups/show/ExportShareLinks';

export default class Show extends BaseView {

    initialize({ params }) {

        this.groupId = params[0];
        this.groupModel = Backbone.Collection.groups.get(this.groupId);
        this.setElement(Template({
            Styles,
            hasStudentsOrIsNotTeacher: this.groupModel.students.length > 0 || !Backbone.Model.user.get('is_teacher'),
            isStudentOrMobile: Backbone.Model.user.get('is_student') || ISMOBILE,
            hasContent: this.groupModel.chapters.length > 0,
            manageStudentsUrl: `<a href='/groups/settings/${this.groupId}'>`,
            addContentUrl: `<a href='/library/home/${this.groupId}'>`
        }));

        Backbone.View.header.clearButtons()
        Backbone.View.header.setTitle(window.i18n.gettext('Learning material'))
        Backbone.View.header.setCrumblepath(
            this.groupModel.getAllCrumblepathModels(),
            'show'
        )

        if (this.groupModel.hasModules()) {
            for (const model of this.groupModel.modules) {
                this.addSvelteChildView(
                    '.js-chapters',
                    Module,
                    {
                        model,
                    }
                )
            }
        } else {
            for (const model of this.groupModel.chapters) {
                this.addChildView(new ChapterView({ model }), '.js-chapters')
            }
        }

        // For students, also show progress bars and most recent activity
        if (ACL.checkRole(ACL.roles.STUDENT)) {
            const contentDomain = this.groupModel.getContentDomain()
            if (contentDomain) {
                createContentDomainFilterHeroDropdown(
                    this.groupModel,
                    (selectedContentDomainId) => this.getProgress(selectedContentDomainId)
                )
            } else {
                this.getProgress()
            }
        }

        this.addHeroButtonForTheoryCollection()
        this.addHeroButtonForTeacherMaterial()
        this.addHeroButtonForSearch()
        this.addHeroOptionsDropdown()

        if (Backbone.Model.user.get('is_demo')) {
            setTimeout(_.bind(this.openToolTipForGroupsShow, this), 100);
        }
    }

    /**
         * openToolTipForGroupsShow
         *
         * This functions opens a tooltip that points towards the second section of chapter 1.
         *
         */
    openToolTipForGroupsShow() {
        var firstSectionOfFirstChapter = this.$('.js-chapter:nth-child(1) .js-section-item:nth-child(1)');
        var secondSectionOfFirstChapter = this.$('.js-chapter:nth-child(1) .js-section-item:nth-child(2)');
        if (secondSectionOfFirstChapter.length) {
            Backbone.View.layout.addTourTooltip({
                message: window.i18n.gettext('Choose a section'),
                target: secondSectionOfFirstChapter,
                left: true
            });
        } else if (firstSectionOfFirstChapter.length) {
            Backbone.View.layout.addTourTooltip({
                message: window.i18n.gettext('Choose a section'),
                target: firstSectionOfFirstChapter,
                left: true
            });
        }
    }

    getProgress(contentDomainId = null) {
        let url = `/groups/progress_student/${this.groupModel.id}.json`
        if (Number.isInteger(contentDomainId)) {
            url += `?content_domain_item_id=${contentDomainId}`
        }
        $.get({
            url,
            success: (response) => {

                // Set the progress for each section
                for (const chapter of response.chapters || []) {
                    for (const section of chapter.progress || []) {
                        const sectionModel = Backbone.Collection.sections.get(section.section_id)
                        sectionModel?.set({
                            progress: section.progress
                        })
                    }
                }

                // Use the activity id with latest response to show the most recent section
                const sectionModel = Backbone.Collection.activities.get(response.lastActivityId)?.getSectionModel()
                this.unregisterAndDestroyChildView(this.recentSection)
                if (sectionModel) {
                    this.recentSection = this.addChildView(
                        new ContentLabel({
                            model: sectionModel
                        }),
                        '.js-recent-progress-section'
                    )
                    this.$('.js-recent-progress').css('visibility', 'visible')
                } else {
                    this.$('.js-recent-progress').hide()
                }
            },
            error: (response) => {
                // No need to display an error when the request fails
                response.failSilently = true
            }
        })
    }

    addHeroButtonForTheoryCollection() {
        if (this.groupModel.theoryBooks.length === 1) {
            Backbone.View.header.addButton(new HeroButton({
                firstLine: window.i18n.gettext('Open theory'),
                icon: 'theory',
                callback: () => {
                    Backbone.View.layout.openTheory(this.groupModel.theoryBooks.at(0).id)
                },
            }))

            return
        }

        if (this.groupModel.theoryBooks.length > 1) {
            Backbone.View.header.addButton(
                new HeroDropdown({
                    firstLine: window.i18n.gettext('Open theory'),
                    icon: 'theory',
                    dropdownItems: this.groupModel.theoryBooks.map(theoryBook => ({
                        icon: 'theory',
                        label: theoryBook.get('name'),
                        callback: () => {
                            Backbone.View.layout.openTheory(theoryBook.id)
                        }
                    }))
                })
            )
        }
    }

    addHeroButtonForTeacherMaterial() {

        // Only teachers can view this
        if (!ACL.isAllowed(ACL.resources.TEACHER_MATERIALS, ACL.actions.VIEW) || ISMOBILE) {
            return
        }

        // Check if teacher materials are present
        const teacherMaterials = this.groupModel.get('TeacherMaterials')
        if (teacherMaterials.length === 1) {
            Backbone.View.header.addButton(new HeroButton({
                firstLine: window.i18n.gettext('Teacher materials'),
                icon: 'attachment',
                callback: () => {
                    Backbone.history.navigate(
                        `/groups/teacher_materials/${this.groupModel.id}/${teacherMaterials.at(0).id}`,
                        { trigger: true }
                    )
                },
            }))
            return
        }

        // If multiple are present, list them in a dropdown
        if (this.groupModel.get('TeacherMaterials').length > 1) {
            Backbone.View.header.addButton(
                new HeroDropdown({
                    firstLine: window.i18n.gettext('Teacher materials'),
                    icon: 'attachment',
                    dropdownItems: this.groupModel.get('TeacherMaterials').map(material => ({
                        icon: 'attachment',
                        label: material.name,
                        callback: () => {
                            Backbone.history.navigate(
                                `/groups/teacher_materials/${this.groupModel.id}/${material.id}`,
                                { trigger: true }
                            )
                        }
                    }))
                })
            )
            return
        }

        // Fallback for the old style teacher materials
        // TODO: remove this when content migration is done
        const teacherMaterialCollection = new Backbone.Collection(
            this.groupModel.publishedContent.filter((publishedContent) => publishedContent.get('teacher_material'))
        )
        if (teacherMaterialCollection.length) {
            Backbone.View.header.addButton(new HeroButton({
                firstLine: window.i18n.gettext('Teacher materials'),
                icon: 'attachment',
                callback: () => {
                    Backbone.View.Components.fullscreen.open(TeacherMaterialModal, {
                        title: new ContentLabel({
                            model: this.groupModel,
                            hasNoLink: true,
                            labelPrefix: window.i18n.gettext('Teacher materials')
                        }).el.outerHTML,
                        collection: teacherMaterialCollection
                    })
                },
            }))
        }
    }

    addHeroButtonForSearch() {
        const searchButton = Backbone.View.header.addButton(
            new HeroButton({
                firstLine: window.i18n.gettext('Search'),
                icon: 'search',
                callback: () => {
                    searchInput.setVisible(true)
                }
            })
        )

        const searchInput = this.addSvelteChildView('.js-search-input', SearchInput, {
            groupId: this.groupId,
            searchButtonElement: searchButton.el
        })
    }

    // Set content visibility for all activities in the group
    addHeroButtonForSetVisibility() {
        if (!ACL.checkRole(ACL.roles.TEACHER) || ISMOBILE || Backbone.Model.user.get('exam_product')) {
            return
        }

        Backbone.View.header.addButton(
            new HeroButton({
                firstLine: window.i18n.gettext('Set visibility'),
                icon: 'eye',
                callback: () => this.openSetVisibilityModal()
            })
        )
    }

    openSetVisibilityModal() {
        Backbone.View.Components.modal.open(SetVisibility, {
            title: window.i18n.gettext('Set visibility'),
            model: this.groupModel
        })
    }

    addHeroOptionsDropdown() {
        const dropdownItems = []

        if (ACL.checkRole(ACL.roles.TEACHER) && !ISMOBILE) {
            dropdownItems.push({
                label: window.i18n.gettext('Set visibility'),
                icon: 'eye',
                callback: () => this.openSetVisibilityModal()
            })
        }

        if (ACL.checkRole(ACL.roles.TEACHER)) {
            dropdownItems.push({
                label: window.i18n.gettext('Export shareable links'),
                icon: 'hyperlink',
                callback: () => exportShareLinks(this.groupModel)
            })
        }

        if (!dropdownItems.length) {
            return
        }

        Backbone.View.header.addButton(
            new HeroDropdown({
                firstLine: window.i18n.gettext('Options'),
                icon: 'arrow-drop-down-circle',
                dropdownItems
            })
        )
    }

}
